var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCyrclePreloader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 308 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes news-slider-preloader{0%{transform:rotate(0);transform-origin:center center}to{transform:rotate(360deg);transform-origin:center center}}")), /*#__PURE__*/React.createElement("g", {
    id: "blue-cyrcle-preloader_svg__news-slider-preloader",
    style: {
      animation: "news-slider-preloader 1.8s linear infinite"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3867B1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M119.058 107.832c5.89 0 10.666-4.777 10.666-10.667 0-5.892-4.776-10.667-10.666-10.667-5.892 0-10.667 4.775-10.667 10.667 0 5.89 4.775 10.667 10.667 10.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.364 90.21c4.166 4.165 10.92 4.165 15.085 0 4.165-4.166 4.165-10.92 0-15.085-4.165-4.167-10.919-4.167-15.085 0-4.166 4.165-4.166 10.919 0 15.084z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M178.133 97.059c0 5.89 4.774 10.666 10.667 10.666 5.89 0 10.667-4.776 10.667-10.666 0-5.892-4.777-10.667-10.667-10.667-5.893 0-10.667 4.775-10.667 10.667zM195.753 124.365c-4.166 4.166-4.166 10.919 0 15.085 4.166 4.165 10.92 4.165 15.084 0 4.166-4.166 4.166-10.919 0-15.085-4.164-4.166-10.918-4.166-15.084 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M161.598 173.753c-4.165-4.165-10.919-4.165-15.084 0-4.166 4.166-4.166 10.92 0 15.085 4.165 4.166 10.919 4.166 15.084 0 4.167-4.165 4.167-10.919 0-15.085z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M129.829 166.905c0-5.891-4.775-10.667-10.666-10.667-5.89 0-10.667 4.776-10.667 10.667s4.777 10.667 10.667 10.667c5.891 0 10.666-4.776 10.666-10.667z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M112.209 139.599c4.166-4.165 4.166-10.919 0-15.084-4.166-4.166-10.919-4.166-15.085 0-4.166 4.165-4.166 10.919 0 15.084 4.166 4.166 10.919 4.166 15.085 0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M188.905 156.133c-5.891 0-10.667 4.774-10.667 10.667 0 5.89 4.776 10.667 10.667 10.667 5.89 0 10.666-4.777 10.666-10.667 0-5.893-4.776-10.667-10.666-10.667z"
  }))));
}
export default SvgBlueCyrclePreloader;